





































import { formatNumber } from '~/utils/number'
import { defineComponent } from '~/utils/nuxt3-migration'
import CChart from '~/components/shared/configurable/chart/CChart.vue'

export default defineComponent({
  components: { CChart },
  props: {
    stats: {
      type: Object,
      required: true
    },
    cost: {
      type: Number,
      default: 0
    },
    duration: {
      type: String,
      default: ''
    },
    inPrevious: {
      type: Boolean,
      default: false
    },
    paymentType: {
      type: String,
      default: 'credits'
    }
  },
  computed: {
    showStats() {
      return this.stats?.plot?.xAxis?.values?.length
    },
    chartConfig() {
      return {
        type: 'line',
        data: {
          labels: this.stats.plot.xAxis.values.map(
            (v: { label: string }) => v.label
          ),
          datasets: this.stats.plot.yAxles.map(
            (axis: { label: string; values: number[] }, index: number) => {
              const colors = [
                { line: '#3b82f6', fill: 'rgba(59, 130, 246, 0.1)' },
                { line: '#10b981', fill: 'rgba(16, 185, 129, 0.1)' },
                { line: '#f59e0b', fill: 'rgba(245, 158, 11, 0.1)' }
              ]
              return {
                label: axis.label,
                data: axis.values,
                borderColor: colors[index].line,
                backgroundColor: colors[index].fill,
                borderWidth: 1.5,
                tension: 0.4,
                fill: true,
                pointRadius: 0
              }
            }
          )
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          interaction: {
            mode: 'index',
            intersect: false
          },
          scales: {
            x: {
              ticks: {
                display: false
              },
              grid: {
                display: false
              }
            },
            y: {
              ticks: {
                autoSkip: true,
                autoSkipPadding: 20,
                font: {
                  size: 11
                }
              }
            }
          },
          plugins: {
            tooltip: {
              mode: 'index',
              intersect: false,
              backgroundColor: 'rgba(255, 255, 255, 0.9)',
              titleColor: '#666',
              bodyColor: '#666',
              borderColor: '#e1e1e1',
              borderWidth: 1,
              padding: 10,
              displayColors: true,
              boxWidth: 8,
              boxHeight: 8,
              boxPadding: 6,
              usePointStyle: true,
              callbacks: {
                title: (tooltipItems: any[]) => {
                  return tooltipItems[0].label
                }
              }
            },
            legend: {
              position: 'bottom',
              onClick: () => {},
              labels: {
                boxWidth: 6,
                boxHeight: 6,
                usePointStyle: true,
                pointStyle: 'circle',
                padding: 15,
                font: {
                  size: 11
                }
              }
            }
          }
        }
      }
    },
    impressions() {
      return formatNumber(this.stats.total.impressions)
    },
    clicks() {
      return formatNumber(this.stats.total.clicks)
    },
    allClicks() {
      return formatNumber(this.stats.total.all_clicks)
    },
    formatedCost() {
      return formatNumber(this.cost)
    },
    isPaymentTypeStripe() {
      return this.paymentType === 'stripe'
    }
  }
})
